import { view } from './view';

export const info = document.querySelector('.info');
export const header = document.querySelector('#main-header');
export const me = document.querySelector('.me');
export const btnAbout = document.querySelector('.btn-about');
export const infoItems = document.querySelector('.info-items');
export const infoItem = document.querySelector('.info-item');
export const percentages = document.querySelectorAll('.tech-percentage');
export const titleDark = document.querySelectorAll('.title-dark');
export const description = document.querySelector('.description');
export const navbar = document.querySelector('#navbar');
export const navContainer = document.querySelector('.nav-container');
export const navLink = document.querySelectorAll('.nav-link');
export const progress = document.querySelector('.progress');
export const cubeWrapper = document.querySelector('.cube-wrapper');
export const works = document.querySelector('.works');
export const project = document.querySelector('.project');
export const projectOverlay = document.querySelector('.project-overlay');
export const hamburger = document.querySelector('.hamburger');

view.generateCards(works);
export const projectCollection = document.querySelectorAll('.card');
